<div tabindex="0" class="tooltip" [class]="position">
  <div class="content-wrapper">
    <span>?</span>
    <div class="content" *ngIf="content" [innerHTML]="content"></div>
    <div class="content" *ngIf="!content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
